"use strict";
/**
 * Created on 07 13 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link WindowItemForecastChange}.</p>
 *
 * @author JMe
 */


var WindowItemForecastChangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemForecastChangeConverter, _DataObjectConverter_);

  function WindowItemForecastChangeConverter() {
    _classCallCheck(this, WindowItemForecastChangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastChangeConverter).apply(this, arguments));
  }

  return WindowItemForecastChangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemForecastChangeConverter = WindowItemForecastChangeConverter;